import system from "./modules/system";
import map from "./modules/map";
import getters from "./getters";

const store = {
    modules: {
        system,
        map,
    },
    getters
};
export default store;
